import './TextHolderBg.min.css';

interface Props {
    title: string;
    icon: string;
    hasImg: boolean;
    isTextCentered: boolean;
};

const TextHolderTitle: React.FC<Props> = ({ title, icon, hasImg, isTextCentered }) => {

    const hasLineBetween = !!title && !!icon;
    const hasLineUnder = (!hasLineBetween && (title || icon));

    if (!title && !icon) return null;

    return <div className="pt-3 pt-md-0">

        <h2 className={`h2 arimo text-holder-title
            ${isTextCentered? 'justify-content-center text-center': 'justify-content-start text-start'}
            ${hasLineBetween ? "d-lg-flex" : "d-block"}`}>

            {
                icon &&
                <i className={icon + " minisite-font-36 "}></i>
            }

            {
                hasLineBetween &&
                <>
                    <span className="mst-vl d-none d-md-none d-lg-inline-block mx-4">&nbsp;</span>
                    <span className={`mst-hr px-2 d-block d-md-block d-lg-none mt-2 ${isTextCentered? 'mx-auto': ''}`}>&nbsp;</span>
                </>
            }

            {
                title &&
                <span className="mst-title-string " dangerouslySetInnerHTML={{ __html: title }}>
                </span>
            }

        </h2>

    </div>

}

export default TextHolderTitle;